import { useFormikContext } from "formik"
import "react-csv-importer/dist/index.css"

import { ImportAccountNumbersFormValues } from "../accountNumbersTypes"
import {
    FormikImportCsvFile,
    ImportCsvFileField,
} from "../../../../../../shared/components/importCsv/FormikImportCsvFile"

export const ImportFile = () => {
    const { values } = useFormikContext<ImportAccountNumbersFormValues>()

    const { dimensionId } = values

    const fieldsConfig: ImportCsvFileField[] = [
        { name: "accountNumber", label: "Account number", optional: false },
        { name: "accountName", label: "Account name", optional: false },
        { name: "assignToAll", label: "Assign to all", optional: true },
        { name: "assignToDepartmentNos", label: "Assign to department numbers", optional: true },
    ]

    return <FormikImportCsvFile<ImportAccountNumbersFormValues> fields={fieldsConfig} disabled={!dimensionId} />
}
